import { render, staticRenderFns } from "./select-account.vue?vue&type=template&id=71852ada&scoped=true"
import script from "./select-account.vue?vue&type=script&lang=js"
export * from "./select-account.vue?vue&type=script&lang=js"
import style0 from "./select-account.vue?vue&type=style&index=0&id=71852ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71852ada",
  null
  
)

export default component.exports